import { render } from "./authorStory.vue?vue&type=template&id=385f44c7&scoped=true"
import script from "./authorStory.vue?vue&type=script&lang=js"
export * from "./authorStory.vue?vue&type=script&lang=js"

import "./authorStory.vue?vue&type=style&index=0&id=385f44c7&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385f44c7"]])

export default __exports__